export default "{{$ctrl.time_formatted}}";